import React, { createContext, useContext, useEffect, useState } from "react";
import dataService from "../services/dataService";

const StaticOptionsContext = createContext(null);

export const StaticOptionsProvider = ({ children }) => {
	const [staticOptions, setOptions] = useState({});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);


	const rama_koztalp_talp_szinek = [
		{ label: "fehér", value: "2" },
		{ label: "bézs", value: "3" },
		{ label: "barna", value: "4" },
		{ label: "fekete", value: "5" },
		{ label: "kék", value: "6" },
		{ label: "piros", value: "7" },
		{ label: "zöld", value: "8" }
	];

	const rind_options = [
		{ value: "Normál", label: "Normál" },
		{ value: "Előrevezetett - mindkét oldal", label: "Előrevezetett - mindkét oldal" },
		{ value: "Előrevezetett - külső oldal", label: "Előrevezetett - külső oldal" },
		{ value: "Előrevezetett - belső oldal", label: "Előrevezetett - belső oldal" },
		{ value: "Berlini - mindkét oldal", label: "Berlini - mindkét oldal" },
		{ value: "Berlini - külső oldal", label: "Berlini - külső oldal" },
		{ value: "Berlini - belső oldal", label: "Berlini - belső oldal" },
	];

	const tuzes_szinek = [
		{ label: "fekete", value: "5" },
		{ label: "barna", value: "4" },
		{ label: "piros", value: "7" },
		{ label: "kék", value: "6" },
		{ label: "zöld", value: "8" },
		{ label: "sárga", value: "9" }
	];

	useEffect(() => {
		console.log("StaticOptionsProvider useEffect called");
		const fetchOptions = async () => {
			try {
				const [all_options, user_prefs] = await Promise.all([
					dataService.getAllOptions(),
					dataService.getUser_prefs(),
				]);
				setOptions({
					spec_aid_types: all_options.data.data.spec_aid_types,
					components: all_options.data.data.components,
					shoes_med_types: all_options.data.data.shoes_med_types,
					corner_types: all_options.data.data.corner_types,
					corner_materials: all_options.data.data.corner_materials,
					shoe_horn_models: all_options.data.data.shoe_horn_models,
					shoe_top_leathers: all_options.data.data.shoe_top_leathers,
					linermaterials: all_options.data.data.linermaterials,
					corner_heights: all_options.data.data.corner_heights,
					shoe_color_options: all_options.data.data.shoe_color_options,
					rama_colors: rama_koztalp_talp_szinek,
					rind_options: rind_options,
					tuzes_szinek: tuzes_szinek,
					foot_liners: all_options.data.data.foot_liners,
					foot_sizes: all_options.data.data.foot_sizes,
					taxes: all_options.data.data.taxes,
					pmodes: all_options.data.data.pmodes,
					sole_ramas: all_options.data.data.sole_ramas,
					midsole_colors: all_options.data.data.midsole_colors,
					rama_types_and_colors: all_options.data.data.rama_types_and_colors || [],
					user_prefs: user_prefs.data?.data || {},
				});
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};
		fetchOptions();
	}, []);

	return <StaticOptionsContext.Provider value={{ staticOptions, loading, error }}>{children}</StaticOptionsContext.Provider>;
};

export const useStaticOptions = () => useContext(StaticOptionsContext);
